import axios from 'axios'
import { addTraceIdHeader } from '@vvc/shared'

// Determine BaseURL based on environment
// - Development mode (yarn dev): local galigulu at 127.0.0.1:9001
// - Production mode (build): relative path (current deployed server)
const isDev = process.env.NODE_ENV === 'development'
const baseURL = isDev ? (process.env.VUE_APP_API_BASE || 'http://127.0.0.1:9001') : ''

const service = axios.create({
  baseURL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可以在这里添加 token (如果有)
    const token = localStorage.getItem('loginToken')
    if (token) {
        // config.headers['Authorization'] = token
    }

    // Add client trace ID
    addTraceIdHeader(config)

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 参考 plugin 的返回结构 { status: 0, data: ... }
    // 如果 status 不是 0，视作业务错误 (具体状态码需根据后端约定)
    if (res.status !== undefined && res.status !== 0) {
      // 可以在这里处理全局错误，如 token 过期
      return Promise.resolve(res) // 返回完整 res 让业务层处理特定 status
    }
    return res
  },
  error => {
    console.error('Request Error:', error)
    return Promise.reject(error)
  }
)

export default service
